import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendIntegrationAsset, BackendQueryIntegrationAssetsArgs } from 'src/types/backend';

import { INTEGRATION_ASSET } from './schema';

const QUERY = gql`
  query IntegrationAssets(
    $userId: ID
    $customerId: ID!
    $workspaceId: ID
    $dataSource: PerformanceCenterDataSource
    $integrationAssetId: ID
    $accountId: ID
    $statuses: [IntegrationAssetStatus!]
    $refresh: Boolean
  ) {
    integrationAssets(
      userId: $userId
      customerId: $customerId
      workspaceId: $workspaceId
      dataSource: $dataSource
      integrationAssetId: $integrationAssetId
      accountId: $accountId
      statuses: $statuses
      refresh: $refresh
    ) {
      ...IntegrationAsset
    }
  }
  ${INTEGRATION_ASSET}
`;

type Variables = BackendQueryIntegrationAssetsArgs;
type Result = BackendIntegrationAsset[];

export const queryIntegrationAssets = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
